/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RequestReason } from './RequestReason';
import {
    RequestReasonFromJSON,
    RequestReasonFromJSONTyped,
    RequestReasonToJSON,
} from './RequestReason';
import type { RequestStatus } from './RequestStatus';
import {
    RequestStatusFromJSON,
    RequestStatusFromJSONTyped,
    RequestStatusToJSON,
} from './RequestStatus';

/**
 * 
 * @export
 * @interface InvestmentRequest
 */
export interface InvestmentRequest {
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequest
     */
    portfolioGuid: string;
    /**
     * 
     * @type {RequestReason}
     * @memberof InvestmentRequest
     */
    reason: RequestReason;
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequest
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof InvestmentRequest
     */
    requestId: number;
    /**
     * 
     * @type {RequestStatus}
     * @memberof InvestmentRequest
     */
    status: RequestStatus;
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequest
     */
    createdBy: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequest
     */
    createdAt: string;
}



/**
 * Check if a given object implements the InvestmentRequest interface.
 */
export function instanceOfInvestmentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "portfolioGuid" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "requestId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

export function InvestmentRequestFromJSON(json: any): InvestmentRequest {
    return InvestmentRequestFromJSONTyped(json, false);
}

export function InvestmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portfolioGuid': json['portfolio_guid'],
        'reason': RequestReasonFromJSON(json['reason']),
        'description': json['description'],
        'requestId': json['request_id'],
        'status': RequestStatusFromJSON(json['status']),
        'createdBy': json['created_by'],
        'createdAt': json['created_at'],
    };
}

export function InvestmentRequestToJSON(value?: InvestmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'portfolio_guid': value.portfolioGuid,
        'reason': RequestReasonToJSON(value.reason),
        'description': value.description,
        'request_id': value.requestId,
        'status': RequestStatusToJSON(value.status),
        'created_by': value.createdBy,
        'created_at': value.createdAt,
    };
}

